<template>
  
  <div>
    <b-row>
      <!-- Columna Izquierda -->
      <b-card-group class="col-md-4">
        <b-col>

          <InformacionCita 
            :tokenCita="tokenCita"
          />

          <InfoSignosVitales
            v-if="idPaciente"
            :idPaciente="idPaciente"
            :idCitaActual="dataCita.id"
          />

          <HistorialAtenciones
            v-if="idPaciente"
            :idPaciente="idPaciente"
          />
                
          <HistorialImagenesLabs
            v-if="idPaciente"
            :idPaciente = "idPaciente"
          />

          <HistorialDerivacionesInterconsultas
            v-if="idPaciente"
            :idPaciente = "idPaciente"
          />  
        </b-col>
      </b-card-group>


      <b-card-group class="col-md-8">
        <b-col>

          <CrearAnamnesisEditarAtencion 
            :idPaciente="idPaciente" 
            :dataAten = "dataAten"
          />

          <RecetaEditarAtencion/>

          <AtencionImagenes/>
          
          <AtencionLaboratorios :idPaciente="idPaciente" />

          <AtencionTerapias />

          <AtencionProcesos />
          
          <DescansoMedicoEditarAtencion/>
          

          <AtencionDocAs400 v-if="esCoberturaIESS"/>

          <b-row v-if="stDerivaciones && stDerivaciones.length">
            <b-col cols="6" >

              <b-alert show class="mb-3 p-2">
                <h5 class="text-center">DERIVACIONES ENVIADAS</h5>
                <hr class="col-10">

                <div 
                  class="d-flex align-items-center mb-2" 
                  v-for="derivacion in stDerivaciones"
                  :key="derivacion.id"
                >
                  <i class="fa-solid fa-arrow-right mr-1"/> 

                  <h6 class="mb-0"> 
                    {{
                      derivacion.tipoAtencion === '1'
                        ? derivacion.especialidad.descripcion
                        : derivacion.tipoAtencion === '2'
                          ? 'LABORATORIO'
                          : derivacion.tipoAtencion === '3'
                            ? 'IMAGEN'
                            : 'PROCEDIMIENTO'

                    }}
                  </h6>

                </div>
              </b-alert>
            </b-col>


            <b-col cols="6" v-if="stInterconsultas && stInterconsultas.length" >
              <b-alert show  variant="warning" class="mb-3 p-2">
              
                <h5 class="text-center">INTERCONSULTAS ENVIADAS</h5>
                <hr class="col-10">

                <div 
                  class="d-flex align-items-center mb-2" 
                  v-for="interconsulta in stInterconsultas"
                  :key="interconsulta.id"
                >
                  <i class="fa-solid fa-arrow-right mr-1"/> 
                  <h6 class="mb-0"> 
                    {{interconsulta.especialidad.descripcion}}
                  </h6>
                  
                </div>
              </b-alert>

            </b-col>

          </b-row>

          <b-row class="">
            <b-col>
              <DerivacionesInterconsultas/>
            </b-col>
          </b-row>

          <ProcessSignature 
            :base64Signature="base64Signature" 
            isAtencion
            label="Firma Paciente"
          />

          <b-row class="mt-3 ">

            <b-col class="d-flex align-items-center justify-content-end">
              <b-button 
                variant="primary" 
                @click="enviarDatosCompletos"
              >
                Editar Atencion Medica
              </b-button>
            </b-col>
          </b-row>
        </b-col>

      </b-card-group>
    </b-row>

    <b-modal id="pdfModal" title="Visualizar Documento" size="lg">
      <div style="height: 500px">
        <iframe :src="pdfSrc" width="100%" height="100%" style="border: none"></iframe>
      </div>
      <template #modal-footer="{ ok }">
        <b-button variant="primary" :href="pdfSrc" download="Documento.pdf">Descargar PDF</b-button>
        <b-button variant="secondary" @click="ok">Cerrar</b-button>
      </template>
    </b-modal>

    <b-modal
      v-model="showModalDerivaciones"
      hide-footer
      size="lg"
    >
      <h2 class="text-center">Procesos pendientes de la atencion medica</h2>

      <b-card class="mb-0 mt-2" style="border:1px solid #c9c9c9;">

        <div
          v-for="derivacion in derivacionesRegistradas"
          :key="derivacion.id"
          class="d-flex align-items-center justify-content-between my-1 px-2"
        >
          <h6>Derivacion {{derivacion.especialidad}}</h6>
          <b-button
            variant="success"
            @click="onRedirectToDerivacion(derivacion.id)"
          >
            Completar
          </b-button>  
        </div>

        <hr>

        <div
          v-for="interconsulta in interconsultasRegistradas"
          :key="interconsulta.id"
          class="d-flex align-items-center justify-content-between my-1 px-2"
        >
          <h6>Interconsulta {{interconsulta.especialidad}}</h6>
          <b-button
            variant="success"
            @click="onRedirectToInterconsulta(interconsulta.token)"
          >
            Completar
          </b-button>  
        </div>
        
      </b-card>

      <div class="my-1 mb-1 d-flex align-items-center justify-content-end">
        <b-button class="d-flex" @click="onCompletarDespues">
          Completar despues
        </b-button>  
      </div>
      
    </b-modal>
  </div>
</template>

<script>
import { calculateAgeWithDateString, getCurrentDate } from "@/shared/helpers";
import { BootstrapVue } from 'bootstrap-vue';
import { recetaService }         from '@/views/farmacia/services';
import { anamnesisService, diagnosticosService, atencionMedicaService } from '@/views/atencionMedica/services';
import { descansoMedicoService } from '@/views/atencionCita/services';
import rutas from "@/assets/utils/rutas.json";

import { mapState } from "vuex";
import axios from "axios";
import { v4 as uuidv4 } from "uuid";
import Swal from "sweetalert2";

import { imagenesService }       from '@/views/imagen/services';
import { getByToken } from '@/views/atencionMedica/services/atencionMedicaService/getByToken';

import { interconsultaService, derivacionesService  } from '@/views/derivaciones/services';
import { 
  InfoSignosVitales, InformacionCita, HistorialAtenciones, 
  HistorialImagenesLabs, HistorialDerivacionesInterconsultas, AtencionDocAs400,
  AtencionProcesos, AtencionImagenes, AtencionLaboratorios, AtencionTerapias, DerivacionesInterconsultas
}     from "@/views/atencionCita/components";
import { clearDataAtencion, clearAtencionLS, registerExamenes, loadRespaldo, deleteRespaldoAtencion }       from '@/views/atencionCita/helpers';

import CrearAnamnesisEditarAtencion   from "@/views/citas/CrearanamnesisEditarAtencion.vue";
import RecetaEditarAtencion           from '@/views/atencionMedica/components/RecetaEditarAtencion/RecetaEditarAtencion.vue';
import DescansoMedicoEditarAtencion   from '@/views/atencionMedica/components/DescansoMedicoEditarAtencion/DescansoMedicoEditarAtencion.vue';
import { procedimientosService }      from '@/views/procesoclinico/services';
import { ProcessSignature }   from '@/views/topaz/components';
import { ginecologiaService } from "../services";
import { labAuxiliarService } from "../../laboratorio/services";
import { terapiasService }    from "../../terapia/services";
import { fileService } from "../../../shared/services";
import { comprobarRoles } from "../../../shared/helpers";
import { ROLES } from "../../../shared/constants";

export default {

  name: "EditarAtencion",

  components: {

    ...BootstrapVue.components,
    InfoSignosVitales,
    InformacionCita,
    RecetaEditarAtencion,
    DescansoMedicoEditarAtencion,

    HistorialAtenciones,
    HistorialImagenesLabs,
    HistorialDerivacionesInterconsultas,

    CrearAnamnesisEditarAtencion,
    AtencionLaboratorios,
    AtencionDocAs400,

    DerivacionesInterconsultas,
    AtencionImagenes,
    AtencionProcesos,
    AtencionTerapias,
    ProcessSignature
  },

  props: {
    isVisible: {
      type: Boolean,
      default: true,
    },
    isVisibleSecond: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: " Título predeterminado",
    },
  },

  data() {
    return {

      tokenAtencion: "",
      tokenCita: null,

      dataAten : null,
      edadesCitas: null,
      dataPersona: null,
      fecCita: '',
      derivar: false,
      dataCita: null,
      fechasCitas: null,
      esDerivacion: null,
      isInterconsulta: false,

      showModalDerivaciones: false,
      derivacionesRegistradas: [],
      interconsultasRegistradas: [],
      //

      signosCita: null,
      doc: null,
      cacm: null,
      educacioncita: null,
      especialidadcita: null,
      nivelEducacion: "",
      tensionArterialDiastolica: null,
      tensionArterialSistolica: null,
      idPaciente: null,
      consultamedicaid: "",
      encuesta: "",
      observaciones: "",
      tokenEncuestaAM: "",
      tokenaleatorio: "",
      visible: true,
      visibleInfoCita: true,
      visibleAnamnesis: false,
      visibleTarjetaAmarilla: true,
      visiblePediatria: false,
      visiblePsicologia: false,
      visibleGinecologia: false,
      visibleReceta: true,
      visibleImagenes: true,
      visibleLaboratorios: true,
      visibleProcesos: true,
      visibleDescanso: true,
      visibleFirma: false,
      visibleDocumentos: true,
      visibleEncuesta: true,
      visibleTerapias: true,
      visibleCirugias: true,
      visibleHistCli: true,
      visibleHistImg: true,
      collapseItemHistImg: "",
      collapseReceta: "",
      pdfSrc: "",
      idcita: "",
      textoCopy: null,

      callePrincipal: "",
      direccionId: "",
      openOnHover: this.$parent.hover,
      options: {},
      signosVitalesExisten: false,

      temperatura: null,
      itemCita: null,
      dataTerapia: null,
      peso: null,
      tensionArterial: null,
      imc: null,
      pulso: null,
      codEsp: null,
      freqRespiratoria: null,
      satOxigeno: null,
      perimetroCefalico: null,
      talla: null,
      perimetroAbdominal: null,
      estadoSignosvital: null,
      itemSignosVital: null,
      encuestarealizada: false,
      titularesImagenes: [],
      titularesLaboratorios: [],
      titularesTerapias: [],
      
      
      documento: null,
      
      itemCitas: {

        citas: [],
      },
      enc: false,

      clearAtencionLS,
    };
  },


  created() {

    this.tokenAtencion = this.$route.params.token;
    this.identificador = this.tokenAtencion
        
    // limpia al cargar
    this.clearAtencionState();
    clearAtencionLS();
    
    this.obtenerData()

    this.doc = false
    this.enc = false
    localStorage.setItem("doc", this.doc);
    localStorage.setItem("enc", this.enc);

    localStorage.removeItem("idPaciente")
    this.tokenaleatorio = uuidv4();
    this.collapseItemHistim4 = uuidv4();
    this.visible = false;
    this.visibleInfoCita = this.isVisible;
    this.visibleAnamnesis = false;
    this.visibleTarjetaAmarilla = this.isVisibleSecond;
    this.visibleReceta   = this.isVisibleSecond;
    this.visibleImagenes = this.isVisibleSecond;
    this.visibleLaboratorios = this.isVisibleSecond;
    this.visibleDocumentos = this.isVisibleSecond;
    this.visibleEncuesta = this.isVisibleSecond;
    this.visibleProcesos = this.isVisibleSecond;
    this.visibleDescanso = this.isVisibleSecond;
    this.visibleCirugias = this.isVisibleSecond;
    this.visibleTerapias = this.isVisibleSecond;
    this.visibleCirugias = this.isVisibleSecond;
    this.visibleHistCli = false;
    this.visibleHistImg = false;

    this.comprobarPermisos();
    this.setToken();
    
  },



  mounted() {
    clearDataAtencion();
  },


  computed: {
     isJefeMedico() {
      return comprobarRoles([ROLES.JEFE_MEDICO, ROLES.JEFE_VALIDACIONES]);
    },
    accordion() {
      return this.$parent.accordion
        ? `accordion-${this.$parent.collapseID}`
        : null;
    },

    ...mapState({
      stDataCita            : state => state.atencionCita.dataCita,
      stAtencionCita        : state => state.atencionCita,
      stDataSemiologia      : state => state.atencionCita.semiologias?.semActual,
      stAnamnesis           : state => state.atencionCita.anamnesis,
      stImagenes            : state => state.atencionCita.imagenes.imagenesList,
      stMedicamentosList    : state => state.atencionCita.receta.medicamentosList,
      stLaboratoriosList    : state => state.atencionCita.laboratorios.laboratorioList,
      stDescanso            : state => state.atencionCita.descanso.descanso,
      stAlergiasMedicamentos: state => state.atencionCita.receta.alergias,
      stDerivaciones        : state => state.atencionCita.derivacionesInterconsultas?.registradas.derivaciones,
      stInterconsultas      : state => state.atencionCita.derivacionesInterconsultas?.registradas.interconsultas,
      stEditarAtencion      : state => state.atencionMedica.editarAtencion,
      stDocAs400            : state => state.atencionCita.docAs400,

      stAtencionLaboratoriosAs400 : state => state.atencionCita.laboratorios.laboratoriosAs400,
      stAtencionLaboratoriosAux: state => state.atencionCita.laboratorios.laboratoriosAux,
    }),

    esCoberturaIESS() {
      return this.stDataCita?.cobSeleccionada.id === '1'
    },

    base64Signature() {
      if (!this.dataAten?.signature) return null;

      return this.dataAten?.signature;
    },
  },

  methods: {

    async onRegisterDocumentoAS400() {
      
      const newDocAs400 = this.stDocAs400.newFile;
      const oldDocAs400 = this.stDocAs400.urlFile;

      if (!newDocAs400) {
        console.error('No hay newDocAs400');
        return null;
      }

      const urlDocAs400 = await fileService.upload('docAs400', newDocAs400, this.paciente, oldDocAs400);

      if(!urlDocAs400) return null;

      const query = `
        mutation EditarDocumentoCita(
          $citaId: String!, 
          $urlDocAs400: String!
        ) {
          editarDocumentoCita(
            citaId: $citaId, 
            urlDocAs400: $urlDocAs400
          ) {
            status
            message
            docCita {
              id
              token
            }
          }
        }
      `;

      const variables = {
        citaId      : this.dataCita.id,
        urlDocAs400 : urlDocAs400,
      };

      let data = null;

      try {
        const response =  await axios.post(rutas.axios + "api", { query, variables });
        if (response.status !== 200) return null;
         
        const response2 = response.data.data.editarDocumentoCita;
        if (response2.status !== "success") return null;

        data = response2.doccita;

      } catch (err) {
        console.error('Error al registrar documento AS400:', err);
        return null;
      }

      this.processList.push({ text:'Documento Guardado', value: data });

    }, 

    async onRegisterDescansoMedico() {
      let dataDescansosLS = null
      if (this.stDescanso){
        dataDescansosLS = this.stDescanso
      }
      
      const responseDescansos = await descansoMedicoService.update(dataDescansosLS, this.dataAten.id);
    },
    

    async onRegisterExamenes() {
      
      if(this.stAtencionLaboratoriosAs400?.final.length){
        const registerAs400 = await registerExamenes(this.tokenAtencion, this.stAtencionLaboratoriosAs400);
      }

      // guardar auxiliares
      if(this.stAtencionLaboratoriosAux?.length){
        const hayTrabajoQueHacerEnLab = this.stAtencionLaboratoriosAux.some(lab => lab.accion !== 'registrado');

        if(!hayTrabajoQueHacerEnLab) return;

        const dataLabMapped = this.stAtencionLaboratoriosAux.map(          
          d => {
            const { estadoLaboratorio, ...rest } = d; // excluimos estadoLaboratorio

            return {
              ...rest,
              atencionMedica: this.tokenAtencion,
              laboratorios: JSON.stringify(d.laboratorios),
            }
          }
        );

        const registerAuxiliares = await labAuxiliarService.saveLaboratorios(dataLabMapped);
      }
    },



    async onRegisterTerapias() {

      const dataTerapiasLS = loadRespaldo(this.tokenAtencion, 'terapias') || [];

      if(!dataTerapiasLS.length) return;

      const terapiasMap = dataTerapiasLS.map( d => ({
        action          : d.action,
        terapiaId       : d.terapia?.value,
        numeroOrden     : d.numeroOrden,
        cantidad        : d.cantidad,
        motivoSolicitud : d.motivoSolicitud,
        resumenClinico  : d.resumenClinico,
        idRegistro      : d?.idRegistro
      }));

      const responseTerapias = await terapiasService.processEnvios(this.tokenAtencion, terapiasMap);
    },


    async onRegisterProcesosClinicos() {
      const dataEnvioProcedimientos = loadRespaldo(this.tokenAtencion, "procesos") || [];

      console.log("EDITAR PROCSIS", dataEnvioProcedimientos)

      
      if(!dataEnvioProcedimientos.length ) return;

      const envioProcedimientosMap = dataEnvioProcedimientos.map((d) => {
        const isOdonto = d.odonto || !!d.procedimiento_odonto;
        const procedimientoSeleccionado = d.procedimiento || d.procedimiento_odonto;

        return {
          action          : d.action,
          procedimientoId : !isOdonto ? procedimientoSeleccionado?.value : null,
          procOdontoId    :  isOdonto ? procedimientoSeleccionado?.value : null,
          numeroOrden     : d.numeroOrden,
          motivoSolicitud : d.motivoSolicitud,
          resumenClinico  : d.resumenClinico,
          justificacion   : d.justificacion,
          idRegistro      : d.idRegistro
        };
      });

      console.log("EDITAR PROCSIS 2", envioProcedimientosMap)

      const responseSave = await procedimientosService.processEnvios(this.tokenAtencion, envioProcedimientosMap);

      console.log('proc saved', responseSave);
    },


    async onUpdateDiagnosticos(){

      const dataDiagnosticosLS = loadRespaldo(this.tokenAtencion, 'diagnosticos');

      const { inicial, final } = dataDiagnosticosLS;

      const diagnosticosToCreate   = final.filter(d => !d.id);
      const diagnosticosToDelete   = inicial.filter(
        i => !final.some(f => f.id === i.id)
      );
      const diagnosticosToUpdate   = final.filter(
        f => f.id && inicial.some(i => i.id === f.id)
      );

      const dToCreateMap = diagnosticosToCreate.map(
        d => ({ 
          atencionMedica : this.dataAten.id,
          diagnostico    : d.diagnostico.value,
          tipoDiagnostico: d.tipo.value,
          esPrincipal    : d.principal ? "1" : "0"
        })
      );

      const dToUpdateMap = diagnosticosToUpdate.map(
        d => ({ 
          id             : d.id,
          diagnostico    : d.diagnostico.value,
          tipoDiagnostico: d.tipo.value,
          esPrincipal    : d.principal ? "1" : "0"
        })
      );

      const dToDeleteMap = diagnosticosToDelete.map(
        d => d.id
      )

      const diagnosticosToProcess = {
        diagnosticosToCreate: dToCreateMap,
        diagnosticosToUpdate: dToUpdateMap,
        diagnosticosToDelete: dToDeleteMap,
      };

      const responseDiagnosticos = await diagnosticosService.multipleProcesos(diagnosticosToProcess);
    },


    async onRegisterAntecedentes() {
      const query = ` 
        mutation MyMutation2(
          $tokenAtencion : String!, 
          $dictAnteFam:String, 
          $dictAntePer: String
        ) {
        updateAntecedentes(
          tokenAtencion: $tokenAtencion,
          dictAnteFam: $dictAnteFam, 
          dictAntePer: $dictAntePer
        ) {
            message
            status
          }
        }
      `;
      
      try {

        let antePer = this.stAnamnesis.antecedentesPersonales
        antePer = JSON.stringify(antePer)
        let anteFam = this.stAnamnesis.antecedentesFamiliares
        anteFam = JSON.stringify(anteFam)

        const variables = {
          tokenAtencion : this.tokenAtencion,
          dictAntePer : antePer,
          dictAnteFam : anteFam
        }

        const response = await axios.post(rutas.axios + "api", { query, variables });
        
      } catch (error) {
        console.error("Error :", error);
      }
    },


    async onUpdateGinecologia(){
      const dataGinecoLS = loadRespaldo(this.tokenAtencion, 'antecedentesGinecologicos');
      if (!dataGinecoLS) return;
      if(!dataGinecoLS.items) return;

      const tokenAntecedentes = dataGinecoLS.tokenAntecedentes;

      const dataGineco = {
        dataItems: JSON.stringify(dataGinecoLS.items),
      }

      const responseGineco = tokenAntecedentes 
        ? await ginecologiaService.updateAntecedentesByToken(tokenAntecedentes, dataGineco)
        : await ginecologiaService.registerAntecedentes(this.tokenAtencion, dataGineco);

    },

    async onRegisterAnamnesis() {

      const last_odontograma_inicial = await anamnesisService.lastOdontogramaInicial(this.stDataCita.paciente.id)
      const odontograma_id = last_odontograma_inicial?.id

      if (odontograma_id && this.isJefeMedico) {
        const odontograma_nuevo = await anamnesisService.saveOdontogramaInicial(
          this.dataCita.id,
          this.stDataSemiologia,
          odontograma_id

        );

        console.log("ODONTOGRAMA ACTUALIZADO", odontograma_nuevo)
      }

      await this.onUpdateDiagnosticos();

      let idAnamnesis = null
      if(this.stAnamnesis !==  null) idAnamnesis = this.stAnamnesis.idAnamnesis;

      const inputAnamnesis = { input: {
        anamnesisId    : idAnamnesis,
        motivoConsulta : this.stAnamnesis.motivoConsulta ? this.stAnamnesis.motivoConsulta.textoMotivo ? this.stAnamnesis.motivoConsulta.textoMotivo : this.stAnamnesis.motivoConsulta  : this.stAnamnesis.motivoConsulta,
        problemaActual : this.stAnamnesis.problemaActual,
        ptratamiento   : this.stAnamnesis.planTratamiento,
        tipoConsulta   : this.stAnamnesis.ocurrencia ? this.stAnamnesis.ocurrencia.value ? this.stAnamnesis.ocurrencia.value : this.stAnamnesis.ocurrencia : this.stAnamnesis.ocurrencia,
        // diagnosticos   : JSON.stringify(this.stAnamnesis.diagnostico),
        revorganos     : JSON.stringify(this.stAnamnesis.revisionOrganos),
        examfisico     : JSON.stringify(this.stAnamnesis.examenFisico)
      } }
           
      const responseAnamnesis = await anamnesisService.update(inputAnamnesis);
    },

    async onRegisterImagenes() {

      const dataImagenesLS = loadRespaldo(this.tokenAtencion, 'imagenes') || [];

      console.log("IMAGENES STORAGE", dataImagenesLS)

      if(!dataImagenesLS.length) return;

      const mergeNumeroPieza = (texto = "", numeroPieza) => {
        const base = (texto || "").replace(/,?\s*Numero de Pieza:.*$/i, "").trim();
        const numero = (numeroPieza ?? "").toString().trim();
        if (!numero) return base;
        const sep = base ? ", " : "";
        return `${base}${sep}Numero de Pieza: ${numero}`;
      };

      const imagenesMap = dataImagenesLS.map( d => ({
        action          : d.action,
        diagnostico     : d.diagnostico || null,
        imagenId        : d.imagen?.value,
        numeroOrden     : d.numeroOrden,
        lateralidad     : d.lateralidad.value,
        numeroPieza     : d.numeroPieza,
        motivoSolicitud : mergeNumeroPieza(d.motivoSolicitud, d.numeroPieza),
        resumenClinico  : mergeNumeroPieza(d.resumenClinico, d.numeroPieza),
        sedacion        : d.sedacion,
        justificacion   : d.justificacion,
        idRegistro      : d?.idRegistro
      }));

      const responseImagenes = await imagenesService.processEnvios(this.tokenAtencion, imagenesMap);
      
    },


    async onRegisterReceta(){
      const dataRecetaLS = this.stMedicamentosList || [];
      const alergias = this.stAlergiasMedicamentos
      const responseReceta = await recetaService.update(this.dataAten.id, dataRecetaLS, alergias);
    },


    async obtenerData(){
      try{

        this.tokenAtencion = this.$route.params.token
        this.dataAten = await getByToken(this.tokenAtencion);

        this.dataCita = this.dataAten.cita
        this.tokenCita = this.dataAten.cita.token

        this.idPaciente = this.dataAten.cita.paciente.id
        
        const idAnamnesis = this.dataAten?.anamnesisSet[0]?.id
       
        this.dataCita.paciente.persona.edad = calculateAgeWithDateString(this.dataCita.paciente.persona.fechaNacimiento);

        this.$store.commit("setDataCita", this.dataCita);

        this.$store.commit("setIdAnamnesis", idAnamnesis);
      
        const dataStateAp = {
          noRefiere:true,
          items: [],
          observaciones:{
            active: false,
            text: '',
          }
        }
    
        if(this.dataAten.anteperanamSet && this.dataAten.anteperanamSet.length > 0 && this.dataAten.anteperanamSet[0].descripcionGeneral !== 'No refiere'){
       
          dataStateAp.noRefiere = false
          if(this.dataAten.anamnesisSet && this.dataAten.anamnesisSet[0] && this.dataAten.anamnesisSet[0].obsadicionalAp ){
            dataStateAp.observaciones.active = true
            dataStateAp.observaciones.text = this.dataAten.anamnesisSet[0].obsadicionalAp
          }
          
          for(let i = 0; i < this.dataAten.anteperanamSet.length; i++){
            let estado = this.dataAten.anteperanamSet[i].estado
            if (estado && estado === '1') {
              dataStateAp.items.push({
                anio : this.dataAten.anteperanamSet[i].anio,
                estado : this.dataAten.anteperanamSet[i].estado,
                id: this.dataAten.anteperanamSet[i].antescedentesPersonales.id,
                inputText: this.dataAten.anteperanamSet[i].descripcionGeneral,
                text : this.dataAten.anteperanamSet[i].antescedentesPersonales.descripcion,
                value : this.dataAten.anteperanamSet[i].antescedentesPersonales.descripcion.toLowerCase(),
                esHistorial : true,
              })
            }
          }
        }
      
        this.$store.commit("setAntecedentesPersonales", dataStateAp);

        // CARGAR ANTECEDENTES FAMILIARES
        const dataStateAf = {
          noRefiere:true,
          items: [],
          observaciones:{
            active: false,
            text: '',
          }
        }

        if(this.dataAten.antefamanamSet && this.dataAten.antefamanamSet.length > 0 && this.dataAten.antefamanamSet[0].descripcionGeneral !== 'No refiere'){
       
          dataStateAf.noRefiere = false
          if(this.dataAten.anamnesisSet && this.dataAten.anamnesisSet[0] && this.dataAten.anamnesisSet[0].obsadicionalAf ){
            dataStateAf.observaciones.active = true
            dataStateAf.observaciones.text = this.dataAten.anamnesisSet[0].obsadicionalAf
          }

          for(let i = 0; i < this.dataAten.antefamanamSet.length; i++){
            let arrayFam = [];
            let familiarData = this.dataAten.antefamanamSet[i].familiar
            if (Array.isArray(familiarData)) {
              arrayFam = familiarData.map(f => ({ value: f.toLowerCase(), text: f }));
            } else if (typeof familiarData === 'string') {
              arrayFam = familiarData.split(", ").map(f => ({ value: f.toLowerCase(), text: f }));
            }
            let estado = this.dataAten.antefamanamSet[i].estado
            if (estado && estado === '1'){
              dataStateAf.items.push({
                familiar : arrayFam,             
                familiarText: this.dataAten.antefamanamSet[i].familiar,
                estado : this.dataAten.antefamanamSet[i].estado,
                id       : this.dataAten.antefamanamSet[i].antescedentesFamiliares.id,
                inputText: this.dataAten.antefamanamSet[i].descripcionGeneral,
                text     : this.dataAten.antefamanamSet[i].antescedentesFamiliares.descripcion,
                value    : this.dataAten.antefamanamSet[i].antescedentesFamiliares.descripcion.toLowerCase(),

                esHistorial: true
              })
            }
          }  
        }
      
        this.$store.commit("setAntecedentesFamiliares", dataStateAf);

        const dataStateRo = {
          items: [],
          observaciones:{
            active: false,
            text: '',
          }
        }
      
        if(this.dataAten.revorganamSet && this.dataAten.revorganamSet.length > 0 ){
       
          for(let i = 0; i < this.dataAten.revorganamSet.length; i++){
            dataStateRo.items.push({
              checked : false,
              id: i + 1,
              inputText: this.dataAten.revorganamSet[i].descripcionGeneral,
              selecteds : [],
              estado : this.dataAten.revorganamSet[i]?.estado,
              idRevOrg : this.dataAten.revorganamSet[i]?.id,
              idRevOrgItem : this.dataAten.revorganamSet[i]?.revisionorganos?.id,
              text : this.dataAten.revorganamSet[i]?.revisionorganos?.descripcion,
              value : this.dataAten.revorganamSet[i]?.revisionorganos?.descripcion.toLowerCase()
            })
          }
        }
      
        this.$store.commit("setRevisionOrganos", dataStateRo);
        
        if(this.dataAten.anamnesisSet && this.dataAten.anamnesisSet.length > 0 ){
          const anam = this.dataAten.anamnesisSet[0]
          let dataMotivo = null
          
          if (anam.motivoConsulta)
            dataMotivo = anam.motivoConsulta
          
          const ocurrencia = this.dataAten.tipoConsulta?.id

          this.$store.commit("setMotivoConsulta", dataMotivo);
          this.$store.commit("setPlanTratamiento", anam.ptratamiento);
          this.$store.commit("setProblemaActual", anam.problemaActual);
          this.$store.commit("setMotivoConsulta", dataMotivo);
          this.$store.commit("setOcurrencia", ocurrencia);
        }
      
        const medicamentoList = []
        if(this.dataAten.recetaSet && this.dataAten.recetaSet.length > 0 ){

          const recet = this.dataAten.recetaSet
      
          if(recet && recet.length > 0 && recet[0].medicamentosRecetados && recet[0].medicamentosRecetados.length > 0){
            this.$store.commit("setAlergias", recet[0].alergias)
            let medicamentosRecetados = recet[0].medicamentosRecetados
            
            medicamentosRecetados.forEach(med => {
              medicamentoList.push({
                estado            : med.estado,
                tokenReceta       : recet[0].token,
                idReceta          : recet[0].id,
                tokenMedicamento  : med.token,
                idMedicamento     : med.id,
                alertaOmitida     : parseInt(med.alertaIgnorada, 10),
                cantidad          : med.cantidad.toString(),
                dosis             : med.dosis,
                duracion          : med.duracion,
                frecuencia        : med.frecuencia,
                id                : med.id,
                medicamento       : med.medicamento.nombre,
                medicamentoID     : med.medicamento.id,
                estadoTransitorio : med.estadoTransitorio,
                observacion       : med.observacion,
                via               : med.medicamento.presentacion
              })
            })
          
          }
        
          this.$store.commit("setMedicamentosList", medicamentoList);
        }

        if(this.dataAten.envioimagenSet && this.dataAten.envioimagenSet.length > 0 ){
          const imagen = this.dataAten.envioimagenSet
          const imagenList = await this.cargarDataImagenes(imagen)
            
          this.$store.commit("setImagenesList", imagenList);
        }


        if (this.dataAten.derivacionesSet.length){
          const derivaciones = this.dataAten.derivacionesSet;
          const derivacionesActivas = derivaciones.filter( d => d.estado === '1');
          this.$store.commit("setDerivacionesRegistradas", derivacionesActivas);
        }

        if (this.dataAten.interconsultasSet.length){
          const interconsultas = this.dataAten.interconsultasSet;
          this.$store.commit("setInterconsultasRegistradas", interconsultas);
        }
       

        // CARGAR DATA DESCANSO
        if(this.dataAten.descansomedicoSet && this.dataAten.descansomedicoSet.length > 0 ){
          const desc = this.dataAten.descansomedicoSet[0]
          const descanso = 
          {
            actividadlab    : desc.actividadlab,
            aislamiento     : desc.aislamiento,
            contingencia    : desc.contingencia,
            diasdescanso    : desc.diasdescanso,
            empresa         : desc.empresa,
            observacion     : desc.observacion,
            direccion       : desc.direccion,
            tipodiagnostico : desc.tipodiagnostico ? desc.tipodiagnostico.id : null,
            idDescanso      : desc.id,
            estado          : desc.estado
          }
        
          this.$store.commit("setDescanso", [descanso]);
        
        }
      
        if(this.dataAten.cita && this.dataAten.cita.documentoscitaSet && this.dataAten.cita.documentoscitaSet.length > 0 ){
          const urlDescanso = this.dataAten.cita.documentoscitaSet[this.dataAten.cita.documentoscitaSet.length - 1].urlsDocAs400;
          this.$store.commit("setDocAs400", urlDescanso);
        }
      }catch(error){
        console.log("este es el error", error)
      }
      
    },


    async cargarDataImagenes(imagen){
      let imagenesList = []
      if (imagen && imagen.length > 0){
        imagen.forEach(img => {
          imagenesList.push({
            alertaIgnorada : img.alertaIgnorada,
            imagenId : img.imagen.id,
            imagentext : img.imagen.nombre,
            lateralidad : img.lateralidad.descripcion,
            lateralidadId : img.lateralidad.id,
            motivosolicitud : img.motivoSolicitud,
            norden : img.numeroOrdenAs400,
            resumen : img.resumenClinico,
            tokenEnvioImagen : img.token,
            estado : img.estado,
            sedacion : img.sedacion

          })
        } )
        
      }
      return imagenesList
    },


    
    citaExists() {
      if (this.itemCita.length > 0) {
        this.educacioncita = this.itemCita[0].nivelEducacion
        this.especialidadcita = this.itemCita[0].especialidadDocid
      } else {
        this.educacioncita = "No proporcionado"
        this.especialidadcita = "No proporcionado"
      }
    },

    async guardarDescanso() {
      const descanso = JSON.parse(localStorage.getItem("descanso")) || [];

      const argDesc = {
        des: descanso,
        consultacita: this.cacm,
      };

      const query = `
        mutation crearDescanso($consultacita : ID!, $des: [DescansoInput!]!) {
          crearDescanso(consultacita: $consultacita, desData: $des ) {
            descansos {
              token
              id 
            }
            status
            message
          }
        }
      `;
      try {
        // Realizar la solicitud GraphQL utilizando axios
        const response = await axios.post(rutas.axios + "api", {
          query: query,
          variables: argDesc,
        });

        // Verificar si la operación fue exitosa
        if (response.data.data.crearDescanso.status === "SUCCESS") {
          // Mostrar una alerta de éxito
          this.$toast.success("Exito Descanso");
        } else {
          // Manejar el caso de error
          this.$toast.error(response.data.data.crearDescanso.message);
        }
      } catch (error) {
        // Mostrar una alerta de error si la solicitud falla
        await this.$swal({
          icon: "error",
          title: "Error",
          text: error.message || "Hubo un problema al crear el descanso.",
        });
      }
    },
    

    recibirTokenEncuesta(token) {
      // Hacer algo con el token recibido, como guardar en el estado del componente padre
      this.tokenEncuestaAM = token;
    },

    showPdfModal(item) {
      this.pdfSrc = item.url; // Utiliza la URL del archivo PDF desde los datos del ítem
      this.$bvModal.show("pdfModal");
    },
    showUploadModal() {
      this.$refs.fileInput.click();
    },
    setToken() {
      const user = JSON.parse(localStorage.getItem("usuario"));
      this.login_user = user.username;
      axios.defaults.headers.common.Authorization = `JWT ${user.token}`; // for all requests
    },
    


    async envioImagen() {
      try {
        this.envImg = JSON.parse(localStorage.getItem("imagenesActual")) || [];

        const solicitudesImagen = this.envImg.map((item) => ({
          imagenId: item.imagenId,
          motivoSolicitud: item.motivosolicitud,
          numeroOrdenAs400: item.norden,
          resumenClinico: item.resumen,
          lateralidadId: parseInt(item.lateralidadId),
          alertaIgnorada: item.alertaIgnorada
        }));
        const argEnvioImagen = {
          enviosDatos: solicitudesImagen,
          cita: this.cacm,
        };

        axios
          .post(rutas.axios + "api", {
            query: `
          mutation CrearEnviosImagen($enviosDatos: [EnvioImagenInput!]!,$cita: String!) {
            crearEnviosImagen(enviosDatos: $enviosDatos, cita: $cita) {
              enviosImagen {
                id
                token
                imagen {
                  id
                  nombre
                }
                consultamedica{
                  cita {
                    id
                    paciente{
                      persona{
                        primerNombre
                      }
                    }
                  }
                }
              }
              status
              message
            }
          }
        `,
            variables: argEnvioImagen,
          })
          .then((response) => {
            if (response.status === 200) {
              if (response.data.data.crearEnviosImagen.status === "Success") {
                this.$toast.success("Exito imagenes");
                localStorage.removeItem("imagenesActual");
              } else {
                this.$toast.error(response.data.data.crearEnviosImagen.message);
              }
            }
          });
      } catch (err) {
        this.$toast.error("Error en crear imagenes: " + err);
      }
    },

    async envioTerapia() {
      try {
        this.envTerp = JSON.parse(localStorage.getItem("atencionTerapias")) || [];
        const solicitudes = this.envTerp.map((item) => ({
          terapiaId: item.terapiaId,
          motivoSolicitud: item.motivosolicitud,
          cantidad: item.cantidad,
          numeroOrdenAs400: item.norden,
          resumenClinico: item.resumen,
          cantidad: item.cantidad,
          alertaIgnorada: item.alertaIgnorada
        }));

        const argEnvioTerapia = {
          solicitudDatos: solicitudes,
          cita: this.cacm,
        };
        axios
          .post(rutas.axios + "api", {
            query: `
            mutation crearSolicitudTerapia($solicitudDatos: [SolicitudTerapiaInput!]!,$cita: String!) {
              crearSolicitudTerapias(solicitudDatos: $solicitudDatos,cita: $cita) {
                solicitudTerapia {
                  id
                  token
                  terapia {
                    id
                    nombre
                  }
                  consultamedica{
                    cita {
                    id
                    paciente{
                      persona{
                        primerNombre
                      }
                    }
                  }
                  }
                }
                status
                message
              }
            }
        `,
            variables: argEnvioTerapia,
          })
          .then((response) => {
            if (response.status === 200) {
              if (
                response.data.data.crearSolicitudTerapias.status === "Success"
              ) {
                //cuando se termina de procesar anamnesis, aqui se procede a guardar las otras variables, tarjeta amarilla
                this.$toast.success(
                  response.data.data.crearSolicitudTerapias.message
                );
                localStorage.removeItem("atencionTerapias");
              } else {
                this.$toast.error(
                  response.data.data.crearSolicitudTerapias.message
                );
              }
            }
          });
      } catch (err) {
        this.$toast.error("Error en crear Terapias: " + err);
      }
    },
    

    async envioReceta() {
      try {
        this.medRec = JSON.parse(localStorage.getItem("atencionReceta")) || [];

        const solicitudesMedicamento = this.medRec.map((item) => ({
          medicamento: item.medicamentoID,
          cantidad: parseInt(item.cantidad, 10),
          dosis: item.dosis,
          frecuencia: item.frecuencia,
          duracion: item.duracion,
          observacion: item.observacion,
          alertaIgnorada: item.alertaOmitida
        }));
        const argMedRec = {
          datos: solicitudesMedicamento,
          citaId: this.cacm, // Asegúrate de que esta sea la forma correcta de obtener el id de la cita
        };
        axios
          .post(rutas.axios + "api", {
            query: `
          mutation CrearMedicamentosRecetados($datos: [MedicamentoRecetadoInput!]!, $citaId: String!) {
            crearMedicamentoRecetados(datos: $datos, citaId: $citaId) {
              medicamentoRecetado {
                id
              }
              message
              status
            }
          }
        `,
            variables: argMedRec,
          })
          .then((response) => {
            if (response.status === 200) {
              if (
                response.data.data.crearMedicamentoRecetados.status ===
                "success"
              ) {
                this.$toast.success("Exito Receta");
                localStorage.removeItem("atencionReceta");
              } else {
                this.$toast.error(
                  response.data.data.crearMedicamentoRecetados.message
                );
              }
            }
          });
      } catch (err) {
        this.$toast.error("Error en crear Receta: " + err);
      }
    },

    clearAtencionState(){
      this.$store.commit("resetAnamnesis");
      this.$store.commit("resetReceta");
      this.$store.commit("resetImagenes");
      this.$store.commit("resetTerapias");
      this.$store.commit("resetDescanso");

      // derivaciones e interconsultas
      this.$store.commit("resetAtencionCita");
      this.$store.commit("resetDerivacionesInterconsultas");
    },

    validateAnamnesis() {

      const diagnosticosRespaldo = loadRespaldo(this.tokenAtencion, 'diagnosticos');
      const hasDiagnosticoPrincipal = diagnosticosRespaldo?.final.find( (d) => d.principal );

      if (!hasDiagnosticoPrincipal) {
        this.$swal({
          title: "Error",
          text: "Debe registrar al menos un diagnostico como principal",
          icon: "error",
          confirmButtonText: "Entendido",
        });
        return false;
      }

      return true;
    },


    async enviarDatosCompletos() {
      try {

        const isValidAnamnesis = this.validateAnamnesis();
        if (!isValidAnamnesis) return;

        let timerInterval;
        Swal.fire({
          title : "Actualizando..",
          timerProgressBar: true,

          didOpen: () => {
            Swal.showLoading();
            timerInterval = setInterval(() => {
              const timer = Swal.getTimerLeft();
              if (timer) {
                Swal.getContent().querySelector("b").textContent = `${timer}`;
              }
            }, 100);
          },
          willClose: () => {
            clearInterval(timerInterval);
          }
        });

        try{
          await this.onRegisterAnamnesis()
        }catch (error) {
          console.log("este es el error anmanesis", error)
        }

        try{
          await this.onRegisterAntecedentes()
        }catch (error) {
          console.log("este es el error antecendentes", error)
        }


        try{
          await this.onUpdateGinecologia()
        }catch(error){
          console.log("este es el error ginecologia", error)
        }


        try{
          await this.onRegisterImagenes();
        }catch (error) {
          console.log("este es el error imagenes", error)
        }

        try{
          await this.onRegisterReceta()
        }catch (error) {
          console.log("este es el error receta", error)
        }

        try{
          await this.onRegisterExamenes()
        }catch (error) {
          console.log("este es el error examenes", error)
        }

        try{
          await this.onRegisterTerapias()
        }catch (error) {
          console.log("este es el error terapias", error)
        }

        try{
          await this.onRegisterProcesosClinicos()
        }catch (error) {
          console.log("este es el error procesos", error)
        }

        try{
          await this.onRegisterDescansoMedico()
        }catch (error) {
          console.log("este es el error descanso", error)
        }

        try{
          if(this.esCoberturaIESS) await this.onRegisterDocumentoAS400();
        }catch (error) {
          console.log("este es el error as400", error)
        }

        try{
          await this.ingresarDerivaciones();
        }catch (error) {
          console.log("este es el error derivaciones", error)
        }

        try{
          await this.ingresarInterconsultas();
        }catch (error) {
          console.log("este es el error interconsultas", error)
        }
        

        // actualizar firma
        const respaldoSignature = loadRespaldo(this.tokenAtencion, 'signature');


        const dataSemiologia = this.stDataSemiologia
          ? JSON.stringify(this.stDataSemiologia)
          : '';
        
        const variables = {
          signature: respaldoSignature,
          semiologia: dataSemiologia
        }
        await atencionMedicaService.updateByToken(this.tokenAtencion, variables);
        
        Swal.close();

        await this.$swal.fire({
          text : "Editado correctamente",
          icon : "success",
        });

        this.clearAtencionState();
        this.clearAtencionLS();
        deleteRespaldoAtencion(this.identificador);

        this.$router.push({ name : 'consultar_citas' });
  
      } catch (err) {
        console.log("este es el error al editar la atencion", err)
      }
    },


    async ingresarDerivaciones(){

      if(!this.stAtencionCita?.derivacionesInterconsultas) return;

      const { derivaciones } = this.stAtencionCita.derivacionesInterconsultas?.crear;

      if( derivaciones.length === 0 ) return;

      derivaciones.forEach( async ( d ) => {
        
        const establecimiento = this.dataAten?.cita?.establecimiento
        let nivelDerivacion = null;

        if (['1', '3', '4'].includes(establecimiento.id)) 
          nivelDerivacion = '1';

        if (['2', '5', '6'].includes(establecimiento.id)) 
          nivelDerivacion = '2';

        const params = {
          idAtencion      : this.dataAten.id,
          especialidad    : d.especialidad?.value,
          tipoAtencion    : d.tipoAtencion?.value.toString(),
          cuadroClinico   : `${this.stAnamnesis?.problemaActual} ${this.stAnamnesis?.antecedentesPersonales?.text || ''}`,
          fechaDerivacion : getCurrentDate(),
          diagnosticos    : JSON.stringify(this.stAnamnesis?.diagnostico),
          nivelDerivacion : nivelDerivacion
        };

        const derivacionResponse = await derivacionesService.registrar(params);        
      });
    },



    async ingresarInterconsultas(){

      if(!this.stAtencionCita?.derivacionesInterconsultas) return;

      const { interconsultas } = this.stAtencionCita?.derivacionesInterconsultas?.crear;

      if( interconsultas.length === 0 ) return;

      const cuadroClinico = `${this.stAnamnesis?.problemaActual} ${this.stAnamnesis?.antecedentesPersonales.text}`;

      interconsultas.forEach( async ( d ) => {

        const params = {
          idAtencion        : this.dataAten.id,
          especialidad      : d.value,
          fechaInterconsulta: getCurrentDate(),
          cuadroClinico     : cuadroClinico,
          planTerapeutico   : this.stAnamnesis?.planTratamiento,
          diagnosticos      : JSON.stringify(this.stAnamnesis?.diagnostico),
          tipo              : '1'
        };
        const data = await interconsultaService.registrar( params );
        if(!data) return;
        
        const interconsultaObj = { ...data, especialidad: d.text };
        this.interconsultasRegistradas.push(interconsultaObj);
      }); 

      // this.showModalDerivaciones = true;
    },

    onCompletarDespues(){
      this.showModalDerivaciones = false;
      this.$router.push({ name: "consultar_citas" });
    },


    onRedirectToDerivacion(derivacionId){
      this.$router.push({ name: "derivaciones", query: { completar:derivacionId } });
    },

    onRedirectToInterconsulta(interconsultaToken){
      this.$router.push({ name: "interconsultas", query:{ completar:interconsultaToken } });
    },


    selectFile() {
      // Esto activará el input para subir archivos
      this.$refs.fileInput.click();
    },
    handleFileUpload(event) {
      const file = event.target.files[0];
      if (file) {
        // Asigna el archivo seleccionado a la variable documento
        this.documento = {
          name: file.name,
          size: file.size,
          file: file, // Guardamos el archivo por si necesitamos usarlo más adelante
        };
      }
      // Limpiar el valor del input para permitir la carga del mismo archivo si se elimina
      event.target.value = null;
    },

    eliminarDocumento(index) {
      this.documento = null;
    },

    viewImage(item) {
      Swal.fire({
        title: item.type,
        text: `Fecha: ${item.content}`,
        imageUrl: "/logo.png", // Ruta relativa al archivo dentro de la carpeta public
        imageWidth: 400,
        imageHeight: 200,
        imageAlt: "Imagen no disponible",
      });
    },
    getFileSize(size) {
      // Esto es para convertir el tamaño del archivo de bytes a un formato más legible
      if (size === 0) return "0 Bytes";
      const k = 1024;
      const dm = 2;
      const sizes = ["Bytes", "KB", "MB", "GB", "TB", "PB"];
      const i = Math.floor(Math.log(size) / Math.log(k));
      return parseFloat((size / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },


    downloadDocument(item) {
      const link = document.createElement("a");
      link.href = "/hoja_amarilla.pdf"; // Ruta del documento
      link.download = "NombreDelDocumento.pdf"; // Nombre sugerido para la descarga
      link.dispatchEvent(new MouseEvent("click"));
    },

    

    calculateAge(birthdate) {
      if (birthdate) {
        const today = new Date();
        const birthDate = new Date(birthdate);
        let age = today.getFullYear() - birthDate.getFullYear();
        const m = today.getMonth() - birthDate.getMonth();
        if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
          age--;
        }
        return age;
      } 
      
      return 0;
    },


    comprobarPermisos() {
      const permisosUsuario = localStorage.getItem('permisos');

      const requiredPermission = this.$route.meta.requiredPermission;

      if (permisosUsuario.indexOf(requiredPermission) === -1) {
        this.$router.push({ name: 'not-permitted' });
      } else {
        console.log("El usuario tiene permiso para acceder a esta ruta.");
      }
    },

  },
  
};
</script>

<style>
.scrollable-content {
  max-height: 200px;
  /* Ajusta según tus necesidades */
  overflow-y: auto;
}

.custom-button-color {
  background-color: #3498db;
  /* Color azul */
  border-color: #2980b9;
  /* Color azul oscuro para el borde */
  color: #ffffff;
  /* Color de texto blanco */
}

/* Para cambiar el color al pasar el mouse (hover) */
.custom-button-color:hover {
  background-color: #2980b9;
  /* Color azul oscuro */
}
</style>
